import React, { useCallback, useState } from "react";
import "./Customers.css";
import Container from "react-bootstrap/Container";
import { Row, Col, InputGroup, Form, Button } from "react-bootstrap";
import Sidebar from "../../components/Sidebar/Sidebar";
import {
  getSelectedState,
  Grid,
  GridColumn as Column,
} from "@progress/kendo-react-grid";
import "@progress/kendo-theme-default/dist/all.css";
import * as GrIcons from "react-icons/gr";
import * as RiIcons from "react-icons/ri";
import { DataLoader } from "../../utils/DataLoader";
import { getter } from "@progress/kendo-data-query";
import { ArchiveCustomers } from "../../apis/CustomerAPI";
import { confirmAlert } from "react-confirm-alert";
import { useAlert } from "react-alert";
import Loader from "../../components/Loader";

export default function ArchivedCustomers() {
  const alert = useAlert();
  const SELECTED_FIELD = "selected";
  const DATA_ITEM_KEY = "id";
  const idGetter = getter(DATA_ITEM_KEY);
  const [selectedState, setSelectedState] = useState({});
  const [totalPage, setTotalPage] = useState(0);
  const [showArchiveBtn, setShowArchiveBtn] = useState(false);
  const [archiveIds, setArchiveIds] = useState([]);

  const [showLoader, setShowLoader] = useState(false);

  const ControllerNActionName = {
    ControllerName: "Customer",
    ActionName: "getallcustomers",
    SearchField: "customer_name",
  };
  const [customers, setCustomers] = useState({
    data: [],
    total: 0,
  });

  const [searchText, setSearchText] = useState(null);
  const [dataState, setDataState] = useState({
    take: 50,
    skip: 0,
    filter: "0",
  });
  const handleClick = () => {
    let stext = searchText;
    localStorage.setItem("searchData", true);
    setDataState({ take: 50, skip: 0, filter: stext });
  };
  const dataStateChange = (e) => {
    setDataState(e.dataState);
  };
  const dataReceived = (customers) => {
    setTotalPage(customers.total);
    setCustomers(customers);
  };
  const initialSort = [
    {
      field: "customer_id",
      dir: "desc",
    },
  ];
  const [count, setCount] = useState(1);
  const [sort, setSort] = React.useState(initialSort);
  const handleSorting = (e) => {
    localStorage.setItem("sortData", true);
    let sortingArray = e.sort;
    sortingArray.forEach((element, i) => {
      if (element.field === "id") {
        e.sort[i].field = "customer_id";
        e.sort[i].dir = count % 2 == 0 ? "desc" : "asc";
      } else if (element.field === "customerName") {
        e.sort[i].field = "customer_name";
        e.sort[i].dir = count % 2 == 0 ? "desc" : "asc";
      } else if (element.field === "requestorCount") {
        e.sort[i].field = "requestor_count";
        e.sort[i].dir = count % 2 == 0 ? "desc" : "asc";
      }
    });
    setCount(count + 1);
    setSort(e.sort);
  };

  const onSelectionChange = useCallback(
    (event) => {
      const newSelectedState = getSelectedState({
        event,
        selectedState: selectedState,
        dataItemKey: DATA_ITEM_KEY,
      });
      setSelectedState(newSelectedState);
      //showArchiveButton
      let newIds = [];
      for (const prop in newSelectedState) {
        if (newSelectedState[prop]) newIds.push(prop);
      }
      setArchiveIds(newIds);
      if (newIds.length > 0) setShowArchiveBtn(true);
      else setShowArchiveBtn(false);
    },
    [selectedState]
  );

  const onHeaderSelectionChange = useCallback((event) => {
    const checkboxElement = event.syntheticEvent.target;
    const checked = checkboxElement.checked;
    const newSelectedState = {};
    event.dataItems.forEach((item) => {
      newSelectedState[idGetter(item)] = checked;
    });
    setSelectedState(newSelectedState);
    let newIds = [];
    for (const prop in newSelectedState) {
      if (newSelectedState[prop]) newIds.push(prop);
    }
    setArchiveIds(newIds);
    if (newIds.length > 0) setShowArchiveBtn(true);
    else setShowArchiveBtn(false);
  }, []);

  const handleUnArchiveCustomers = (e) => {
    e.preventDefault();
    let title = "Unarchive Customer";
    let msg = "Are you sure want to unarhive this customer?";
    if (archiveIds.length > 1){
      msg = "Are you sure want to unarchive these customers?";
      title = "Unarchive Customers";
    }
    confirmAlert({
      title: title,
      message: msg,
      buttons: [
        {
          label: "Yes",
          className: "yesbtn",
          onClick: async () => {
            setShowLoader(true);
            var result = await ArchiveCustomers(
              JSON.stringify(archiveIds),
              false
            );
            if (result.status === 200) {
              alert.success("Customers unarchived successfully", {
                onOpen: () => {
                  localStorage.setItem("searchData", true);
                  setDataState({ take: 50, skip: 0, filter: "" });
                  setShowArchiveBtn(false);
                },
                onClose: () => setShowLoader(false),
              });
            } else
              alert.error("Unable to unarchive customers", {
                onClose: () => setShowLoader(false),
              });
          },
        },
        {
          label: "No",
          className: "nobtn",
        },
      ],
    });
  };

  return (
    <>
      <Container fluid>
        <Row>
          <div className="admin-wrapper">
            <div className="left-section">
              <Sidebar />
            </div>
            <div className="right-section">
              <Container fluid>
                <Row className="admin-page-row orders">
                  <Col lg={6} md={6} sm={12}>
                    <div className="page-title">
                      <h2>Archived Customers</h2>
                    </div>
                  </Col>
                  <Col lg={6} md={6} sm={12}>
                    <div className="search-filter customer-search">
                      <div className="filters-option">
                        <div className="search-by-filter">
                          <InputGroup>
                            <Form.Control
                              placeholder="Search by Customer Name"
                              aria-label="Search by"
                              aria-describedby="Search-by"
                              value={searchText}
                              onChange={(e) => setSearchText(e.target.value)}
                            />
                            <Button
                              onClick={handleClick}
                              className="search-btn"
                              type="btn"
                              id="Search-by"
                            >
                              <i className="fa-solid fa-magnifying-glass"></i>
                            </Button>
                          </InputGroup>
                        </div>
                        <div className="multi-options-filter">
                          <a
                            className="userimg"
                            href="/Admin/ArchivedCustomers"
                            onClick={handleUnArchiveCustomers}
                            style={
                              showArchiveBtn
                                ? { display: "inline-block" }
                                : { display: "none" }
                            }
                          >
                            <RiIcons.RiArchiveDrawerLine />
                            <Loader visible={showLoader} />
                          </a>
                          
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Grid
                    sortable={true}
                    sort={sort}
                    onSortChange={(e) => {
                      handleSorting(e);
                    }}
                    pageable={true}
                    {...dataState}
                    data={customers.data.map((item) => ({
                      ...item,
                      [SELECTED_FIELD]: selectedState[idGetter(item)],
                    }))}
                    total={totalPage}
                    onDataStateChange={dataStateChange}
                    style={{ height: "75vh" }}
                    dataItemKey={DATA_ITEM_KEY}
                    selectedField={SELECTED_FIELD}
                    selectable={{
                      enabled: true,
                      drag: false,
                      cell: false,
                      mode: "multiple",
                    }}
                    onSelectionChange={onSelectionChange}
                    onHeaderSelectionChange={onHeaderSelectionChange}
                  >
                    <Column
                      field={SELECTED_FIELD}
                      width="50px"
                      headerSelectionValue={
                        customers.data.findIndex(
                          (item) => !selectedState[idGetter(item)]
                        ) === -1
                      }
                    />
                    <Column field="id" title="Cust.No." />
                    <Column field="customerName" title="Customer" />
                    <Column
                      sortable={false}
                      field="subscriptionType"
                      title="Prepaid/Invoiced"
                    />
                    <Column
                      field="requestorCount"
                      filter="numeric"
                      title="Requester"
                    />
                    <Column
                      sortable={false}
                      field="id"
                      title="Action"
                      width="100px"
                      cell={(props) => (
                        <td className="act">
                          <a
                            href={`/Admin/CustomerViewDetails?id=${props.dataItem.id}`}
                          >
                            <GrIcons.GrFormView />
                          </a>
                        </td>
                      )}
                    ></Column>
                  </Grid>
                  <DataLoader
                    dataState={dataState}
                    onDataReceived={dataReceived}
                    dataItem={ControllerNActionName}
                    dataSort={sort}
                    dataArchived={true}
                  />
                </Row>
              </Container>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
}
